import React from 'react';
import { IOldIconProps } from './type';

const SadCart: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.287 5.767a.75.75 0 00.48.946l1.954.64a2.25 2.25 0 011.48 1.584l2.54 9.988c.198.776.63 1.444 1.209 1.935a3.75 3.75 0 105.05.89h7a3.75 3.75 0 104.876-.998 3.742 3.742 0 001.003-1.547l2.831-8.348a.75.75 0 10-1.42-.482l-2.831 8.348a2.25 2.25 0 01-2.131 1.527H11.376a2.25 2.25 0 01-2.18-1.695L6.654 8.567a3.75 3.75 0 00-2.467-2.639l-1.955-.64a.75.75 0 00-.946.479zM11 21.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM21.75 24a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z"
        fill={color}
      />
      <path
        d="M11 9c1 2 3 2 4 0M11.5 7c1.5 1 3-.5 4-2.5M21 7c-2 1-3-.5-4-2.5M14 16c-2.5-4.5 6.5-5 8 .5M14 16c.5-2 5.75-.864 8 .47M18 9c1 2 3 2 4 0"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SadCart;
